import { render, staticRenderFns } from "./BulkBid.vue?vue&type=template&id=22ed3ddf"
import script from "./BulkBid.vue?vue&type=script&lang=js"
export * from "./BulkBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports